export const validateFormInput = (input) => {
    if (validateRequired(input)) {
        if (input.type === 'email') {
            return validateEmailInput(input)
        }
    } else {
        return false
    }

    return true
}

const validateEmailInput = (input) => {
    const regex = new RegExp('^(.+)@(.+)$')

    if (input.value) {
        return regex.test(input.value)
    } else {
        return true
    }
}

const validateRequired = (input) => {
    if (input.required) {
        return input.value != undefined && input.value != ''
    } else {
        return true
    }
}
